import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { useArrivalChannel } from './useArrivalChannel';

// Channels the productized FCM (`psf_promote_or_share_channel_aware_cta`) governs. Both render the
// "Share on <channel>" button as the sole special action with Copy link in the grid, the winning
// design of the Top-8 relaunch (CHANGE-99290).
const FCM_CTA_CHANNELS = ['facebook', 'whatsapp'] as const;

export type ChannelAwareCtaChannel = (typeof FCM_CTA_CHANNELS)[number];

export type ChannelAwareCta = Readonly<{
	channel: ChannelAwareCtaChannel;
}> | null;

function isFcmCtaChannel(channel: string): channel is ChannelAwareCtaChannel {
	return (FCM_CTA_CHANNELS as readonly string[]).includes(channel);
}

/**
 * Channel-aware share CTA: signers who arrived through a share on a live channel (`current_medium`)
 * get a prominent "Share on <channel>" primary CTA on the share slide-up, matched to their arrival
 * channel. Enabled per-country by the `psf_promote_or_share_channel_aware_cta` FCM (also its
 * kill-switch: empty list = off for that country).
 *
 * Returns which channel's CTA to render, or `null` (production sheet).
 */
export function useChannelAwareCta(): ChannelAwareCta {
	const {
		data: { channelAwareCtaChannels },
	} = usePsfPromoteOrSharePageData();
	const arrivalChannel = useArrivalChannel();
	if (!arrivalChannel || !isFcmCtaChannel(arrivalChannel)) return null;
	if (!channelAwareCtaChannels.includes(arrivalChannel)) return null;
	return { channel: arrivalChannel };
}
